import request from '@/utils/request'
/**
 * 菜单操作API
 * @author Jay Qing
 * @since 2020/12/01
 */

export const BASE_URL = '/system/menu-action'

export function authActionInterface(data: { actionId: number; interfaceIds: number[] }) {
  return request({
    url: `${BASE_URL}/authActionInterface`,
    data,
    method: 'post'
  })
}

/**
 * 分页查询接口
 *
 * @type {string}
 */
export const PAGE_URL = `${BASE_URL}/page`

export function get(id: any) {
  return request({
    url: BASE_URL + '/get/' + id,
    method: 'get'
  })
}

export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}
